import { Box } from '@mui/material';

import { ProjectsListPageHeader } from '../containers/ProjectListPageHeader/ProjectsListPageHeader';
import { ProjectsListPageContent } from '../containers/ProjectsListPageContent/ProjectsListPageContent';
import { ProjectModalProvider } from '../context/modalContext';

export const ProjectsListPage = () => {
  return (
    <ProjectModalProvider>
      <Box>
        <ProjectsListPageHeader />
        <ProjectsListPageContent />
      </Box>
    </ProjectModalProvider>
  );
};
